type PhoneCodeEntry = {
  id: string;
  phoneCode: string;
};

export const countriesToPhoneCodeList: Array<PhoneCodeEntry> = [
  { id: 'AF', phoneCode: '93' },
  { id: 'DZ', phoneCode: '213' },
  { id: 'AR', phoneCode: '54' },
  { id: 'AU', phoneCode: '61' },
  { id: 'BH', phoneCode: '973' },
  { id: 'BE', phoneCode: '32' },
  { id: 'BO', phoneCode: '591' },
  { id: 'BR', phoneCode: '55' },
  { id: 'BG', phoneCode: '359' },
  { id: 'CA', phoneCode: '1' },
  { id: 'CL', phoneCode: '56' },
  { id: 'CN', phoneCode: '86' },
  { id: 'CO', phoneCode: '57' },
  { id: 'CR', phoneCode: '506' },
  { id: 'HR', phoneCode: '385' },
  { id: 'CY', phoneCode: '357' },
  { id: 'CZ', phoneCode: '420' },
  { id: 'DK', phoneCode: '45' },
  { id: 'DO', phoneCode: '1' },
  { id: 'EC', phoneCode: '593' },
  { id: 'EG', phoneCode: '20' },
  { id: 'SV', phoneCode: '503' },
  { id: 'FI', phoneCode: '358' },
  { id: 'FR', phoneCode: '33' },
  { id: 'DE', phoneCode: '49' },
  { id: 'GR', phoneCode: '30' },
  { id: 'GT', phoneCode: '502' },
  { id: 'HK', phoneCode: '852' },
  { id: 'HU', phoneCode: '36' },
  { id: 'IN', phoneCode: '91' },
  { id: 'ID', phoneCode: '62' },
  { id: 'IL', phoneCode: '972' },
  { id: 'IT', phoneCode: '39' },
  { id: 'JP', phoneCode: '81' },
  { id: 'JO', phoneCode: '962' },
  { id: 'KE', phoneCode: '254' },
  { id: 'KW', phoneCode: '965' },
  { id: 'LU', phoneCode: '352' },
  { id: 'MY', phoneCode: '60' },
  { id: 'MV', phoneCode: '960' },
  { id: 'MX', phoneCode: '52' },
  { id: 'MA', phoneCode: '212' },
  { id: 'NL', phoneCode: '31' },
  { id: 'NZ', phoneCode: '64' },
  { id: 'OM', phoneCode: '968' },
  { id: 'PA', phoneCode: '507' },
  { id: 'PE', phoneCode: '51' },
  { id: 'PH', phoneCode: '63' },
  { id: 'PL', phoneCode: '48' },
  { id: 'PT', phoneCode: '351' },
  { id: 'QA', phoneCode: '974' },
  { id: 'RO', phoneCode: '40' },
  { id: 'RU', phoneCode: '7' },
  { id: 'SA', phoneCode: '966' },
  { id: 'SN', phoneCode: '221' },
  { id: 'RS', phoneCode: '381' },
  { id: 'SG', phoneCode: '65' },
  { id: 'ZA', phoneCode: '27' },
  { id: 'KR', phoneCode: '82' },
  { id: 'ES', phoneCode: '34' },
  { id: 'LK', phoneCode: '94' },
  { id: 'SE', phoneCode: '46' },
  { id: 'CH', phoneCode: '41' },
  { id: 'TW', phoneCode: '886' },
  { id: 'TH', phoneCode: '66' },
  { id: 'TN', phoneCode: '216' },
  { id: 'TR', phoneCode: '90' },
  { id: 'AE', phoneCode: '971' },
  { id: 'GB', phoneCode: '44' },
  { id: 'US', phoneCode: '1' },
  { id: 'UY', phoneCode: '598' },
  { id: 'VN', phoneCode: '84' },
];

export function getPhoneCodeByCountryId(countryId: string): string | undefined {
  const country = countriesToPhoneCodeList.find((c) => c.id === countryId);
  return country?.phoneCode;
}
